// extracted by mini-css-extract-plugin
export default {"deliveryDateGroupHeader":"placedOrders_deliveryDateGroupHeader__YX0dB","deliveryDateCell":"placedOrders_deliveryDateCell__PJdV3"};